var $34de119f14549a4b$exports = {};
$34de119f14549a4b$exports = {
    "dropzoneLabel": `\u{653E}\u{7F6E}\u{5340}`,
    "selectPlaceholder": `\u{9078}\u{53D6}\u{9805}\u{76EE}`,
    "tableResizer": `\u{5927}\u{5C0F}\u{8ABF}\u{6574}\u{5668}`,
    "colorSwatchPicker": `Color swatches`
};


export {$34de119f14549a4b$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
